import React from "react"
import Toggle from "react-toggle"
import "react-toggle/style.css"
import * as styles from "./SupplierToggle.module.scss"

const SupplierToggle = (props) => {
  const handleToggle = (e) => {
    if (e.target.checked) {
      props.loadChecked()
    } else {
      props.loadUnchecked()
    }
  }

  return (
    <div className={styles.SupplierToggle}>
      <h3 className={styles.title}>
        <Toggle
          checked={props.checked}
          name={props.name}
          value="yes"
          className="categoryToggle"
          icons={false}
          onChange={handleToggle}
        />
        {props.label}
      </h3>
    </div>
  )
}

export default SupplierToggle
